var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrategicRevenueManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 73H77.5",
    stroke: "#0091C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 30.9,
    width: 8.2,
    height: 42.2,
    stroke: "#0091C4",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 30.5,
    width: 9,
    height: 1,
    fill: "#0091C4",
    stroke: "#0091C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 5.9,
    width: 8.2,
    height: 67.2,
    stroke: "#0091C4",
    strokeWidth: 1.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 5.5,
    width: 9,
    height: 1,
    fill: "#F4F2F2",
    stroke: "#0091C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.9,
    y: 48.9,
    width: 8.2,
    height: 24.2,
    stroke: "#0091C4",
    strokeWidth: 1.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 48.5,
    width: 9,
    height: 1,
    fill: "#0091C4",
    stroke: "#0091C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicRevenueManagement);
export default __webpack_public_path__ + "static/media/strategic-revenue-management.0c2e4c3220fb9d270dfdd868bdb56699.svg";
export { ForwardRef as ReactComponent };